import { useCallback, useRef, useState } from 'react';
import type { MutableRefObject } from 'react';
import { nanoid } from 'nanoid';

const useDeferredRef = <T extends HTMLElement>(
    externalRef?: MutableRefObject<T | null>,
): [MutableRefObject<T | null>, string, (el: T | null) => void] => {
    const internalRef: MutableRefObject<T | null> = useRef<T | null>(null);
    const [signal, setSignal] = useState<string>('');

    // Use external ref if provided, otherwise use internal ref
    const ref: MutableRefObject<T | null> = externalRef ?? internalRef;

    const updateRef = useCallback(
        (el: T | null): void => {
            ref.current = el;
            setSignal(nanoid());
        },
        [ref],
    );

    return [ref, signal, updateRef];
};

export { useDeferredRef };
